<ion-row class="chart-margin lg-space-r">
  <ion-col>
    <div *ngIf="_chartTypes.Aar.active">
      <div class="chart-container" *ngIf="!hasFetchingError; else fetchFailed">
        <app-year-chart-usage
          *ngIf="valgtAarAnlegg; else loadingTemplate"
          [valgtAnlegg]="valgtAarAnlegg"
          [selectedDate]="minDate"
        ></app-year-chart-usage>
      </div>
    </div>

    <div *ngIf="_chartTypes.Maaned.active">
      <div class="chart-container" *ngIf="!hasFetchingError; else fetchFailed">
        <app-month-chart-usage
          *ngIf="valgtMaanedAnlegg; else loadingTemplate"
          [valgtAnlegg]="valgtMaanedAnlegg"
          [selectedYears]="selectedYearsForbrukMonth"
        ></app-month-chart-usage>
      </div>
    </div>

    <div *ngIf="_chartTypes.Dag.active">
      <div class="chart-container" *ngIf="!hasFetchingError; else fetchFailed">
        <app-day-chart-usage
          *ngIf="valgtDagAnlegg; else loadingTemplate"
          [valgtAnlegg]="valgtDagAnlegg"
          [selectedDate]="selectedDateDay"
        ></app-day-chart-usage>
      </div>
    </div>

    <div *ngIf="_chartTypes.Time.active">
      <div class="chart-container" *ngIf="!hasFetchingError; else fetchFailed">
        <app-hour-chart-usage
          *ngIf="valgtTimeAnlegg; else loadingTemplate"
          [valgtAnlegg]="valgtTimeAnlegg"
          [selectedDate]="selectedDateHour"
        ></app-hour-chart-usage>
      </div>
    </div>
  </ion-col>
</ion-row>

<ng-template #fetchFailed>
  <div class="chart-container error">
    <div class="errorMessage">
      <ion-icon name="warning-outline" class="errorIcon"></ion-icon>
    </div>
    <p class="errorMessage">
      Klarte ikke hente data. Prøv igjen senere eller kontakt oss om problemet
      vedvarer.
    </p>
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <div class="loadingContainer">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>
